import { createSvgComponent } from "../../icon/createSvgComponent";
import Web from "@core/__generated__/icon/figma/web.svg";
export default createSvgComponent(Web);